import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOrderProvinceTrend } from '@/views/platformReport/api/index.js';
export default {
  name: 'provinceDetailStatistics',
  props: {
    /**
     * entry 入口类型
     * platformReport - 平台报表-订单消费统计
     * abnormalOrderMonitor - 平台报表-异常订单监控
     * orderListDetail - 订单列表-订单详情
    */
    entry: {
      type: String,
      default: function _default() {
        return 'platformReport';
      }
    },
    /**
     * orderId 订单ID
    */
    orderId: {
      type: [Number, String],
      default: function _default() {
        return '';
      }
    },
    /**
     * categoryId 菜单分类ID
    */
    categoryId: {
      type: [Number, String],
      default: function _default() {
        return '';
      }
    },
    /**
     * orderType 订单类型
    */
    orderType: {
      type: [Number, String],
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      list: [],
      // 下单省份统计 - 列表
      // 饼图配置：key-后端返回pie中的数据字段，refKey-图表容器ref，title-图表标题
      pieChartConfig: [{
        key: 'order_num',
        refKey: 'chartOrderNum',
        title: '订单数下单省份占比'
      }, {
        key: 'amount',
        refKey: 'chartAmount',
        title: '消费点数下单省份占比'
      }],
      provincePaging: {
        page: 1,
        pagesize: 20,
        totalCount: 0
      }
    };
  },
  methods: {
    // 省份是否可点击跳转：非合计/总计行，且province_code必须有值且不为0（含字符串'0'）
    isProvinceClickable: function isProvinceClickable(row) {
      return !['合计', '总计'].includes(row.province_name) && !!row.province_code && Number(row.province_code) !== 0;
    },
    // 点击省份：抛出事件由父组件切换到下单城市 tab
    onClickProvinceName: function onClickProvinceName(row) {
      this.$emit('jump-city', row.province_code);
    },
    headerCellStyle: function headerCellStyle() {
      return {
        background: '#F1F1F1',
        color: '#333333'
      };
    },
    rowStyle: function rowStyle(_ref) {
      var row = _ref.row;
      // 合计/总计行加粗显示
      if (['合计', '总计'].includes(row.province_name)) {
        return {
          fontWeight: 'bold',
          color: '#000'
        };
      } else {
        return {};
      }
    },
    onChangePage: function onChangePage(val) {
      this.provincePaging.page = val;
      this.getProvinceData();
    },
    // 供父组件调用：复位页码后重新查询
    refreshData: function refreshData() {
      this.provincePaging.page = 1;
      this.getProvinceData();
    },
    getProvinceData: function getProvinceData() {
      var _this = this;
      var params = {
        order_id: this.orderId,
        category_id: this.categoryId,
        order_type: this.orderType,
        page: this.provincePaging.page,
        pagesize: this.provincePaging.pagesize
      };
      getOrderProvinceTrend(params, this.entry).then(function (res) {
        var _res$pages;
        var _ref2 = res.data || {},
          pie = _ref2.pie,
          list = _ref2.list,
          total = _ref2.total;
        // 防御后端返回null或非预期类型，避免前端报错
        var safePie = pie && _typeof(pie) === 'object' ? pie : {
          order_num: [],
          amount: []
        };
        _this.list = Array.isArray(list) ? list : [];
        // list有值时把总计行插入到第0个
        if (_this.list.length > 0) {
          _this.list.unshift(_objectSpread({}, total));
        }
        _this.provincePaging.totalCount = (res === null || res === void 0 ? void 0 : (_res$pages = res.pages) === null || _res$pages === void 0 ? void 0 : _res$pages.totalCount) || 0;
        _this.$nextTick(function () {
          _this.handleDrawEchart(safePie);
        });
      });
    },
    // 计算legend换行行数（用于动态下移饼图，避免legend换行过多与图重叠）
    calcLegendRows: function calcLegendRows(chartDom, seriesData) {
      var chartWidth = chartDom.clientWidth || 0;
      if (!chartWidth) {
        return 1;
      }
      // 单个legend项宽度 ≈ icon宽(25) + 项间距(5) + 文本宽度(中文按10px/字估算，padding[-12]抵消一部分)
      var itemWidths = seriesData.map(function (i) {
        return 25 + 5 + String(i.name).length * 10;
      });
      var rows = 1;
      var lineWidth = 0;
      itemWidths.forEach(function (w) {
        if (lineWidth + w > chartWidth) {
          rows++;
          lineWidth = w;
        } else {
          lineWidth += w;
        }
      });
      return rows;
    },
    // 绘制2个饼图：按pieChartConfig依次渲染，每个图取pie中对应key的数据
    handleDrawEchart: function handleDrawEchart(pie) {
      var _this2 = this;
      // 先收集每个图的数据，用于统一计算容器高度
      var chartItems = this.pieChartConfig.map(function (_ref3) {
        var key = _ref3.key,
          refKey = _ref3.refKey,
          title = _ref3.title;
        var chartDom = _this2.$refs[refKey];
        if (!chartDom) {
          return null;
        }
        var seriesData = (pie[key] || []).map(function (i) {
          return {
            value: i.occupancy,
            name: i.name
          };
        });
        return {
          chartDom: chartDom,
          seriesData: seriesData,
          title: title
        };
      }).filter(Boolean);
      // 取两个图legend的最大行数，统一加高容器：省份较多legend换行多时自动撑高，避免挤压重叠
      var maxLegendRows = Math.max.apply(Math, _toConsumableArray(chartItems.map(function (item) {
        return _this2.calcLegendRows(item.chartDom, item.seriesData);
      })));
      // 容器高度 = legend区(顶部30 + 行数*14) + 与图间距40 + 饼图直径(87.5*2) + 底部标签40，最小350
      var chartHeight = Math.max(350, 30 + maxLegendRows * 14 + 40 + 87.5 * 2 + 40);
      chartItems.forEach(function (_ref4) {
        var chartDom = _ref4.chartDom,
          seriesData = _ref4.seriesData,
          title = _ref4.title;
        chartDom.style.height = chartHeight + 'px';
        var legendRows = _this2.calcLegendRows(chartDom, seriesData);
        var legendBottom = 30 + legendRows * 14;
        // 省份较多时只显示占比前20的省份标签，避免文案相互重叠，其余省份可通过tooltip查看
        var labelNames = new Set(_toConsumableArray(seriesData).sort(function (a, b) {
          return b.value - a.value;
        }).slice(0, 20).map(function (i) {
          return i.name;
        }));
        // 不显示标签的数据项同时隐藏引导线
        seriesData.forEach(function (i) {
          var show = labelNames.has(i.name);
          i.label = {
            show: show
          };
          i.labelLine = {
            show: show
          };
        });
        // 半径与商城菜单统计饼图保持一致（其radius:'50%'，容器高350 → 半径87.5px）
        var radiusPx = 87.5;
        var centerY = legendBottom + 40 + radiusPx;
        // 复用已存在的图表实例，避免重复init
        var myChart = _this2.$echarts.getInstanceByDom(chartDom) || _this2.$echarts.init(chartDom);
        // 容器高度变化时先同步图表尺寸，再绘制，避免resize打断入场动画
        if (myChart.getHeight() !== chartDom.clientHeight) {
          myChart.resize();
        }
        var option = {
          title: {
            text: title,
            x: 'center'
          },
          legend: {
            icon: 'circle',
            // 修改形状
            itemHeight: 6,
            // 修改icon图形大小
            itemGap: 5,
            // 修改间距
            textStyle: {
              color: '#333',
              fontSize: 10,
              padding: [0, 0, 0, -12] // 修改文字和图标距离
            },
            top: '30px'
          },
          grid: {
            top: '0'
          },
          tooltip: {
            trigger: 'item',
            valueFormatter: function valueFormatter(value) {
              return value + '%';
            },
            confine: true // 是否将 tooltip 框限制在图表的区域内。
          },
          series: [{
            type: 'pie',
            radius: radiusPx,
            center: ['50%', centerY],
            // 圆心在legend下方，保持固定间距
            label: {
              // formatter为函数时{b}{c}模板不会插值，需自行拼接：名称+占比%
              formatter: function formatter(params) {
                return "".concat(params.name).concat(params.value, "%");
              }
            },
            labelLayout: {
              hideOverlap: true // 仍然重叠的标签自动隐藏
            },
            data: seriesData
          }]
        };
        // notMerge: true 全量替换配置，保证每次都用最新数据完整重绘
        myChart.setOption(option, true);
      });
    }
  }
};